import { QuotationTaxModel } from '../models/comercial/quotation-tax.model';
import { TeleconsultaInterestStateModel } from './../models/comercial/teleconsulta-interest-state.model';
import { Observable } from 'rxjs';
import { ComercialModel } from '../models/comercial/comercial.model';
import { DataComercialEntity } from '../../data/repositories/comercial/entities/comercial.entity';
import { FollowupEntity } from '../../data/repositories/comercial/entities/followup.entity';
import { FollowupResponseModel } from '../models/comercial/followup-response.model';
import { ValidateFollowupModel } from '../models/comercial/validate-followup.model';
import { ProductEntity } from '../../data/repositories/comercial/entities/product.entity';
import { TypeLicenseModel } from '../models/comercial/type-license.model';
import { TeleconsultaInterestInsertModel } from '../models/comercial/teleconsulta-interest-insert.model';
import { ComercialPagedModel, ComercialPagedRequestModel } from '../models/comercial/comercial-paged.model';
import { ComercialDetailModel } from '../models/comercial/comercial-detail.model';
import { FollowupReasonResponseModel } from '../models/comercial/followup-reason.model';
import { CommercialConsentPublicResponseModel, CommercialConsentResponseRequestModel, CommercialConsentResultResponseModel, CommercialConsentPrecheckRequestModel, CommercialConsentPrecheckResponseModel } from '../models/comercial/commercial-consent.model';
import { ContractualValidityResponseModel } from '../models/comercial/contractual-validity.model';
import { AccionElegibleComercialItem, ApiResponse, CatalogoComercialItem, DocumentoComercialItem, OportunidadComercialItem, PlanActivoComercialItem, RelacionComercialItem, RelacionComercialRequest, SeguimientoComercialItem } from '../models/comercial/comercial-v1.model';

export abstract class ComercialRepository {
  abstract insertComercial(
    params: DataComercialEntity
  ): Observable<ComercialModel>;
  abstract insertFollowup(
    params: FollowupEntity
  ): Observable<FollowupResponseModel>;
  abstract getComercialAll(params: {
    idEstadoProspecto: string;
    idUsuarioCreacion: string;
  }): Observable<ComercialModel>;
  abstract getComercialPaged(params: ComercialPagedRequestModel): Observable<ComercialPagedModel>;
  abstract getComercialById(params: { id: string }): Observable<ComercialDetailModel>;
  abstract updateComercial(
    params: DataComercialEntity
  ): Observable<ComercialModel>;
  abstract deleteComercial(params: { Id: string }): Observable<ComercialModel>;
  abstract getTypeLicense(
    params: {id: string;}
  ): Observable<TypeLicenseModel>;
  abstract getFollowupById(params: {
    id: string;
  }): Observable<FollowupResponseModel>;
  abstract getFollowupReasons(params: {
    idTipoSeguimientoProspecto: string;
  }): Observable<FollowupReasonResponseModel>;
  abstract downloadCommercialDocument(params: {
    id: string;
    idSeguimiento: string;
    tipoOrigen: string;
  }): Observable<Blob>;
  abstract downloadSignedConsentDocument(params: { id: string }): Observable<Blob>;
  abstract getValidateComercialFollowup(params: {
    id: string;
    id2: string;
  }): Observable<ValidateFollowupModel>;
  abstract getProduct(): Observable<ProductEntity>;
  abstract saveQuotationTax(params: QuotationTaxModel): Observable<ApiResponse<QuotationTaxModel>>;
  abstract getQuotationTaxes(soloActivos?: boolean): Observable<ApiResponse<QuotationTaxModel[]>>;
  abstract getContractualValidities(): Observable<ContractualValidityResponseModel>;
  abstract getTeleconsultaInterest(params: {
    id: string;
  }): Observable<TeleconsultaInterestStateModel>;
  abstract insertTeleconsultaInterest(params: {
    id: string;
    descripcion: string;
  }): Observable<TeleconsultaInterestInsertModel>;
  abstract getCommercialConsent(params: { token: string }): Observable<CommercialConsentPublicResponseModel>;
  abstract respondCommercialConsent(params: CommercialConsentResponseRequestModel): Observable<CommercialConsentResultResponseModel>;
  abstract precheckCommercialConsent(params: CommercialConsentPrecheckRequestModel): Observable<CommercialConsentPrecheckResponseModel>;
  abstract getResponsablesEmpresa(): Observable<ApiResponse<CatalogoComercialItem[]>>;
  abstract getRelacionesComercialesPaged(params: RelacionComercialRequest): Observable<ApiResponse<RelacionComercialItem[]>>;
  abstract getTiposUltimoSeguimiento(): Observable<ApiResponse<any[]>>;
  abstract getRelacionComercialById(params: RelacionComercialRequest): Observable<ApiResponse<RelacionComercialItem>>;
  abstract getRelacionDocumentos(params: RelacionComercialRequest): Observable<ApiResponse<DocumentoComercialItem[]>>;
  abstract getAccionesElegibles(params: RelacionComercialRequest): Observable<ApiResponse<AccionElegibleComercialItem[]>>;
  abstract getOportunidadesPaged(params: RelacionComercialRequest): Observable<ApiResponse<OportunidadComercialItem[]>>;
  abstract getOportunidadById(params: { id: string }): Observable<ApiResponse<OportunidadComercialItem>>;
  abstract getTiposOportunidad(): Observable<ApiResponse<CatalogoComercialItem[]>>;
  abstract getEstadosOportunidad(): Observable<ApiResponse<CatalogoComercialItem[]>>;
  abstract getPlanesActivosPaged(params: RelacionComercialRequest): Observable<ApiResponse<PlanActivoComercialItem[]>>;
  abstract getSeguimientosPaged(params: RelacionComercialRequest): Observable<ApiResponse<SeguimientoComercialItem[]>>;
  abstract getSeguimientoDetalle(params: { id: string }): Observable<ApiResponse<any>>;

}
